import InputField from "../../../components/Custom/Forms/InputField/InputField";
import {
    UpdateStatePayInMetaDailyLimit,
    UpdateStatePayInMetaMaxLimit,
    UpdateStatePayInMetaMinLimit,
    UpdateStatePayInMetaPerLimit,
} from "../../../redux/slices/statePayInMetaSlice";
import { useDispatch } from "react-redux";
import React from "react";
import { Button } from "reactstrap";
import { onFixed, responseToaster, seperator } from "../../../helperFunctions";

const StatePayInAmount = (props) => {
    const {
        data,
        onGet,
        updateDetails,
        setUpdateDetails,
        setIsLoading,
        disabled
    } = props;
    const dispatch = useDispatch();

    const onUpdate = async (e) => {
        try {
            e.preventDefault();
            setIsLoading(true);

            const payload = {
                stateId: data?.state_id,
                pgName: data?.pg_name,
                id: data?.id,
                pgId: data?.pg_id,
                value: updateDetails?.value,
                merchantId: data?.merchant_id
            };
            switch (updateDetails?.input) {
                case "min":
                    const resMin = await dispatch(
                        UpdateStatePayInMetaMinLimit(payload)
                    ).unwrap();
                    responseToaster(resMin);
                    break;
                case "max":
                    const resMax = await dispatch(
                        UpdateStatePayInMetaMaxLimit(payload)
                    ).unwrap();
                    responseToaster(resMax);
                    break;
                case "daily":
                    const resDaily = await dispatch(
                        UpdateStatePayInMetaDailyLimit(payload)
                    ).unwrap();
                    responseToaster(resDaily);
                    break;
                case "per":
                    const resPer = await dispatch(
                        UpdateStatePayInMetaPerLimit(payload)
                    ).unwrap();
                    responseToaster(resPer);
                    break;
                default:
                    break;
            }
            onGet();
            setUpdateDetails({});
            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);
        }
    };

    return (
        <div className="cell-order">
            <div className="order-singal-div">
                <div>
                    <span>Min Amount : </span>
                    {updateDetails?.input === "min" &&
                        updateDetails?.id === data?.id ? (
                        <form className="d-flex tableinput" onSubmit={onUpdate}>
                            <InputField
                                value={updateDetails?.value}
                                placeholder="Enter Min Amount"
                                autoFocus
                                onChange={(e) =>
                                    setUpdateDetails({
                                        ...updateDetails,
                                        value: e.target.value,
                                    })
                                }
                            />
                            <Button type="submit" color="primary" className="btn-smallsize">
                                <i className="fa-solid fa-check"></i>
                            </Button>
                            <Button
                                type="button"
                                color="danger"
                                className="btn-smallsize"
                                onClick={() => setUpdateDetails({})}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </Button>
                        </form>
                    ) : (
                        <span
                            className="cursor-pointer"
                            style={{ color: "var(--chatlook-darkblue--)" }}
                            onClick={() => {
                                if (disabled) return;
                                setUpdateDetails({
                                    id: data?.id,
                                    input: "min",
                                    value: data?.min_amount,
                                });
                            }}
                        >
                            {`${seperator(data?.min_amount)}`}
                        </span>
                    )}
                </div>
            </div>
            <div className="order-singal-div">
                <div>
                    <span>Max Amount : </span>
                    {updateDetails?.input === "max" &&
                        updateDetails?.id === data?.id ? (
                        <form className="d-flex tableinput" onSubmit={onUpdate}>
                            <InputField
                                autoFocus
                                value={updateDetails?.value}
                                placeholder="Enter Max Amount"
                                onChange={(e) =>
                                    setUpdateDetails({
                                        ...updateDetails,
                                        value: e.target.value,
                                    })
                                }
                            />
                            <Button type="submit" color="primary" className="btn-smallsize">
                                <i className="fa-solid fa-check"></i>
                            </Button>
                            <Button
                                type="button"
                                color="danger"
                                className="btn-smallsize"
                                onClick={() => setUpdateDetails({})}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </Button>
                        </form>
                    ) : (
                        <span
                            className="cursor-pointer"
                            style={{ color: "var(--chatlook-darkblue--)" }}
                            onClick={() => {
                                if (disabled) return;
                                setUpdateDetails({
                                    id: data?.id,
                                    input: "max",
                                    value: data?.max_amount,
                                });
                            }}
                        >
                            {`${seperator(data?.max_amount)}`}
                        </span>
                    )}
                </div>
            </div>
            <div className="order-singal-div">
                <div>
                    <span>Current Turnover : </span>
                    <span>{seperator(data?.current_turnover)}</span>
                </div>
            </div>
            <div className="order-singal-div">
                <div>
                    <span>Daily Limit : </span>
                    {updateDetails?.input === "daily" &&
                        updateDetails?.id === data?.id ? (
                        <form className="d-flex tableinput" onSubmit={onUpdate}>
                            <InputField
                                autoFocus
                                value={updateDetails?.value}
                                placeholder="Enter Daily Limit"
                                onChange={(e) =>
                                    setUpdateDetails({
                                        ...updateDetails,
                                        value: e.target.value,
                                    })
                                }
                            />
                            <Button type="submit" color="primary" className="btn-smallsize">
                                <i className="fa-solid fa-check"></i>
                            </Button>
                            <Button
                                type="button"
                                color="danger"
                                className="btn-smallsize"
                                onClick={() => setUpdateDetails({})}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </Button>
                        </form>
                    ) : (
                        <span
                            className="cursor-pointer"
                            style={{ color: "var(--chatlook-darkblue--)" }}
                            onClick={() => {
                                if (disabled) return;
                                setUpdateDetails({
                                    id: data?.id,
                                    input: "daily",
                                    value: data?.daily_limit,
                                });
                            }}
                        >
                            {`${seperator(data?.daily_limit)}`}
                        </span>
                    )}
                </div>
            </div>
            <div className="order-singal-div">
                <div>
                    <span>% Limit : </span>
                    {updateDetails?.input === "per" &&
                        updateDetails?.id === data?.id ? (
                        <form className="d-flex tableinput" onSubmit={onUpdate}>
                            <InputField
                                autoFocus
                                id={"limit"}
                                value={updateDetails?.value}
                                placeholder="Enter % Limit"
                                onChange={(e) =>
                                    setUpdateDetails({
                                        ...updateDetails,
                                        value: e.target.value,
                                    })
                                }
                            />
                            <Button
                                type="submit"
                                color="primary"
                                className="btn-smallsize"
                            >
                                <i className="fa-solid fa-check"></i>
                            </Button>
                            <Button
                                type="button"
                                color="danger"
                                className="btn-smallsize"
                                onClick={() => setUpdateDetails({})}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </Button>
                        </form>
                    ) : (
                        <span
                            className="cursor-pointer"
                            style={{ color: "var(--chatlook-darkblue--)" }}
                            onClick={() => {
                                if (disabled) return;
                                setUpdateDetails({
                                    id: data?.id,
                                    input: "per",
                                    value: data?.per_limit,
                                });
                            }}
                        >
                            {`${onFixed(data?.per_limit)}%`}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatePayInAmount;
